import axios from "axios";
import { Global } from "../utils/general";
import headerRequest from "../utils/headers";

const API_URL = Global.url;

class ConfiguracionService {
  getConfiguracionCeco() {
    let ruta = `${API_URL}/ceco`;
    return axios
      .get(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }

  guardarConfiguracionesCeco(data) {
    const ruta = `${API_URL}/ceco`;
    return axios
      .post(ruta, data, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }

  getConfiguracionesCeco() {
    const ruta = `${API_URL}/ceco/configuraciones`;

    return axios
      .get(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }
}

export default new ConfiguracionService();
